const formatRetryDelay = (retryAfter) => {
    if (!retryAfter) return '';

    const retryAfterSeconds = Number(retryAfter);
    if (Number.isFinite(retryAfterSeconds)) {
        const seconds = Math.ceil(retryAfterSeconds);
        return seconds > 0 ? ` Spróbuj ponownie za ${seconds} s.` : '';
    }

    const retryAt = Date.parse(retryAfter);
    if (Number.isNaN(retryAt)) return '';

    const seconds = Math.ceil((retryAt - Date.now()) / 1000);
    return seconds > 0 ? ` Spróbuj ponownie za ${seconds} s.` : '';
};

const getApiErrorNotification = (error) => {
    if (error.code === 'ERR_CANCELED') return null;

    if (error.code === 'ERR_IMAGE_LOAD') {
        return {
            title: 'Nie udało się załadować zdjęcia',
            message: 'Sprawdź połączenie internetowe i spróbuj ponownie za chwilę.',
        };
    }

    const status = error.response?.status;
    if (!status) {
        return {
            title: 'Serwer nie odpowiada',
            message:
                error.code === 'ECONNABORTED'
                    ? 'Przekroczono czas oczekiwania na odpowiedź serwera. Spróbuj ponownie za chwilę.'
                    : 'Nie można połączyć się z serwerem. Sprawdź połączenie internetowe i spróbuj ponownie za chwilę.',
        };
    }

    if (status === 429) {
        return {
            title: 'Za dużo zapytań',
            message: `Wysłano zbyt wiele zapytań. Poczekaj chwilę przed ponownym załadowaniem treści.${formatRetryDelay(error.response.headers?.['retry-after'])}`,
        };
    }

    if (status >= 500) {
        return {
            title: 'Błąd serwera',
            message: 'Wystąpił problem po stronie serwera. Spróbuj ponownie za chwilę.',
        };
    }

    const clientErrors = {
        400: {
            title: 'Nieprawidłowe żądanie',
            message: 'Nie udało się przetworzyć żądania. Sprawdź wprowadzone dane.',
        },
        401: {
            title: 'Sesja wygasła',
            message: 'Zaloguj się ponownie, aby kontynuować.',
        },
        403: {
            title: 'Brak dostępu',
            message: 'Nie masz uprawnień do wykonania tej czynności.',
        },
        404: {
            title: 'Nie znaleziono treści',
            message: 'Żądana treść jest niedostępna lub została usunięta.',
        },
        408: {
            title: 'Przekroczono czas oczekiwania',
            message: 'Serwer nie odpowiedział na czas. Spróbuj ponownie za chwilę.',
        },
        409: {
            title: 'Konflikt danych',
            message: 'Dane zmieniły się w międzyczasie. Odśwież stronę i spróbuj ponownie.',
        },
        422: {
            title: 'Nieprawidłowe dane',
            message: 'Podane dane nie mogą zostać przetworzone.',
        },
    };

    return (
        clientErrors[status] || {
            title: 'Błąd żądania',
            message: `Nie udało się wykonać żądania (kod ${status}). Spróbuj ponownie.`,
        }
    );
};

export const notifyApiError = (error) => {
    const notification = getApiErrorNotification(error);
    if (!notification || typeof window === 'undefined') return;

    window.dispatchEvent(
        new CustomEvent('anikino:api-error', {
            detail: notification,
        }),
    );
};
